import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = {
  key: 0,
  class: "table text-center text-secondary"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, "#", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, "Date Created", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "Actions", -1)
const _hoisted_6 = ["id", "value"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "dropdown position-static" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary text-light rounded-pill dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "data-bs-auto-close": "true",
  "aria-expanded": "false"
}, " Actions ", -1)
const _hoisted_11 = {
  class: "dropdown-menu",
  "aria-labelledby": "defaultDropdown"
}
const _hoisted_12 = ["data-bs-images"]
const _hoisted_13 = ["data-bs-images"]
const _hoisted_14 = ["data-bs-images"]
const _hoisted_15 = ["data-bs-images"]
const _hoisted_16 = ["data-bs-images"]

import { projectResultObject, segmentationObject } from "@/interfaces";
import { PropType, ref, onMounted } from "vue";
import ShowImagesModal from "@/components/modals/ShowImagesModal.vue";


const __default__ = {
  name: "ProjectResultTable",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  tableData: {
    type: Array as PropType<Array<projectResultObject>>,
    required: true,
  },
  segmentations: {
    type: Array as PropType<Array<segmentationObject>>,
  },
},
  emits: ["change-selected-results"],
  setup(__props, { emit }) {

const props = __props;



const results = ref<Array<string>>([]);

const tableTitles = ref([]);

const onChangeSelected = () => {
  emit("change-selected-results", results.value);
};

onMounted(() => {
  props.segmentations.forEach((item) =>
    tableTitles.value.push({
      id: item.id,
      label: item.label,
    })
  );
});

const selectAllResults = () => {
  selectAll.value = !selectAll.value;
  if (selectAll.value) {
    results.value = props.tableData.map(function (obj) {
      return obj.id;
    });
  } else {
    results.value = [];
  }
  onChangeSelected();
};

const selectAll = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.tableData)
        ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("input", {
                    id: "all",
                    class: "form-check-input bg-light",
                    type: "checkbox",
                    name: "respondents",
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (selectAllResults()))
                  }, null, 32)
                ]),
                _hoisted_3,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableTitles.value, (data, i) => {
                  return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(data.label), 1))
                }), 128)),
                _hoisted_4,
                _hoisted_5
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableData, (respondent, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: respondent.id,
                      class: "form-check-input bg-light",
                      type: "checkbox",
                      value: respondent.id,
                      name: "respondents",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((results).value = $event)),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (onChangeSelected()))
                    }, null, 40, _hoisted_6), [
                      [_vModelCheckbox, results.value]
                    ])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(respondent.id), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableTitles.value, (data, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, [
                      (respondent.metadata.respondentInfo !== undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(data.label === "All Age-Groups"
                  ? respondent.metadata.respondentInfo["0"]
                  : data.label === "All Genders"
                  ? respondent.metadata.respondentInfo["1"]
                  : respondent.metadata.respondentInfo[data.id]), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, " -- "))
                    ]))
                  }), 128)),
                  _createElementVNode("td", null, _toDisplayString(new Date(respondent.dateCreated).toLocaleDateString()), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("ul", _hoisted_11, [
                        _createElementVNode("li", {
                          class: "text-decoration-none dropdown-item text-secondary cursor-pointer",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#showImagesModal",
                          "data-bs-title": "Heatmaps",
                          "data-bs-images": JSON.stringify(respondent.heatmapsImages)
                        }, " Heatmaps ", 8, _hoisted_12),
                        _createElementVNode("li", {
                          class: "text-decoration-none dropdown-item text-secondary cursor-pointer",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#showImagesModal",
                          "data-bs-title": "Gaze Pattern",
                          "data-bs-images": 
                    JSON.stringify(respondent.gazeLocationImages)
                  
                        }, " Gaze Pattern ", 8, _hoisted_13),
                        _createElementVNode("li", {
                          class: "text-decoration-none dropdown-item text-secondary cursor-pointer",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#showImagesModal",
                          "data-bs-title": "Area of Interest",
                          "data-bs-images": JSON.stringify(respondent.roiImages)
                        }, " Area of Interest ", 8, _hoisted_14),
                        _createElementVNode("li", {
                          class: "text-decoration-none dropdown-item text-secondary cursor-pointer",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#showImagesModal",
                          "data-bs-title": "Emotions",
                          "data-bs-images": JSON.stringify(respondent.emotionsImages)
                        }, " Emotions ", 8, _hoisted_15),
                        _createElementVNode("li", {
                          class: "text-decoration-none dropdown-item text-secondary cursor-pointer",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#showImagesModal",
                          "data-bs-title": "Clicks",
                          "data-bs-images": JSON.stringify(respondent.clicksImages)
                        }, " Clicks ", 8, _hoisted_16)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ShowImagesModal)
  ], 64))
}
}

})